module.exports = __webpack_public_path__ + "static/media/LAVA-USDT.8561b6a4.svg";